// src/pages/ServicesPage.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import Services from "../components/Services";

const ServicesPage = () => {
  return (
    <main className="bg-black text-white">
      {/* ✅ SEO Meta tags */}
      <Helmet>
        <title>Our Travel Services | Rawangi Travel & Tours</title>
        <meta
          name="description"
          content="Explore Rawangi Travel’s professional travel services — air tickets, Umrah, insurance, hotel booking, and more. Honest and reliable travel support for every journey."
        />
      </Helmet>

      {/* Reuse the Services component */}
      <Services />
    </main>
  );
};

export default ServicesPage;
